import { render } from "./PriceListIndex.vue?vue&type=template&id=308a28aa&scoped=true"
import script from "./PriceListIndex.vue?vue&type=script&lang=js"
export * from "./PriceListIndex.vue?vue&type=script&lang=js"

import "./PriceListIndex.vue?vue&type=style&index=0&id=308a28aa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308a28aa"]])

export default __exports__